import React from "react";
import { Link } from "react-router-dom";
import Person from "@mui/icons-material/Person";
import { getUser, logout } from "../../webapi/AuthService";
import HeaderUploadIcon from "../upload/HeaderUploadIcon";

const HeaderMobile = props => {
  return (
    <div className="header">
      <div className="headerSearch"></div>
      <div className="headerMenu">
        <div className="headerMenuItem" onClick={logout}>
          <HeaderUploadIcon />
          <Link to="/signin">
            <span>
              <div style={{ display: "flex" }}>
                {" "}
                <Person />
                <div style={{ marginTop: "2px", marginLeft: "5px" }}>
                  {getUser()}
                </div>
              </div>
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HeaderMobile;
